import { render } from "./OnlineShopping.vue?vue&type=template&id=45a3e9f0&ts=true"
import script from "./OnlineShopping.vue?vue&type=script&lang=ts"
export * from "./OnlineShopping.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__